@if (store.asArray(); as workspaces) {
  @if (workspaces.length > 0) {
    <p-table
      #workspaceTable
      [globalFilterFields]="['name']"
      [loading]="loading"
      [value]="store.asArray()">
      <ng-template pTemplate="caption">
        <app-table-list-caption
          [searchWord]="searchWord"
          (clearTable)="clear(workspaceTable)"
          (search)="
            workspaceTable.filterGlobal($event, 'contains')
          "></app-table-list-caption>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th class="w-1rem" pTooltip="sensibel">
            <i class="fas fa-shield-halved"></i>
          </th>
          <th>Name</th>
          <th>Nutzer:innen</th>
          <th>Aktionen</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-workspace>
        <tr>
          @if (workspace.shy) {
            <td class="w-1rem" pTooltip="sensibel">
              <i class="fas fa-shield-halved"></i>
            </td>
          } @else {
            <td class="w-1rem"></td>
          }
          <td>
            <div class="flex flex-column gap-2">
              <div class="flex align-items-center gap-2">
                <i class="fas fa-users-viewfinder"></i>
                <strong>{{ workspace.name }}</strong>
              </div>
              <div class="flex gap-1">
                @for (
                  countChip of getCountsById(workspace._id);
                  track countChip.value
                ) {
                  @if (countChip.ids.length) {
                    <p-chip>
                      <span class="flex align-items-center gap-2 py-1 text-sm">
                        <i [class]="countChip.icon"></i>
                        <span>{{ countChip.label }}</span>
                        <p-badge
                          [value]="countChip.ids.length"
                          class="-mr-2"></p-badge>
                      </span>
                    </p-chip>
                  }
                }
              </div>
            </div>
          </td>
          <td>
            <div class="flex align-items-center gap-2">
              <p-badge
                [value]="
                  userStore.findByWorkspaceId(workspace._id).length
                "></p-badge>
              Nutzer:innen
            </div>
          </td>
          <td class="w-3rem text-right">
            <app-table-list-actions
              [item]="workspace"
              (confirm)="confirm($event, workspace, workspace.name)">
            </app-table-list-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <app-alert
      styleClass="m-0 p-3 pt-1"
      header="Keine Einträge gefunden"
      severity="info"
      [canToggle]="false">
      Legen Sie
      <a [routerLink]="[{ outlets: { bearbeiten: 'neu' } }]">Arbeitsbereiche</a>
      an, um verschiedene Elemente zu bündeln und mit Rechten zu versehen.
    </app-alert>
  }
}
<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-10'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header>
  </ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
